import { gql } from "@apollo/client";

export const SEND_APP = gql`
  mutation senAppReq($phone: String!, $type: AppType!) {
    Web {
      sendApp(phone: $phone, type: $type)
    }
  }
`;

export const SEND_CHAT = gql`
  mutation send(
    $p_id: Int!
    $content: String!
    $payload: String
    $img: String
    $listing_id: Int
  ) {
    Chat {
      send(
        p_id: $p_id
        content: $content
        payload: $payload
        img: $img
        listing_id: $listing_id
      ) {
        msg_id
      }
    }
  }
`;
